export default __webpack_public_path__ + "static/media/logo.12361409.png";